import { Link, Outlet, createFileRoute } from "@tanstack/react-router"
import { ROLE_LABELS } from "@vienna/contracts"
import { MiniAvatar } from "@/components/workspace/primitives"
import { settingsGroups } from "@/lib/settings-nav"
import { useMe, useWorkspaceContext } from "@/lib/session"

export const Route = createFileRoute("/w/$workspace/settings")({ component: SettingsLayout })

function SettingsLayout() {
  const me = useMe()
  const { workspace, role, isOwner } = useWorkspaceContext()
  return (
    <div className="page-wrap ws-workspace">
      <div className="ws-settings-layout">
        <nav className="ws-settings-nav" aria-label="Settings navigation">
          <h2>Settings</h2>
          {settingsGroups.map((group) => (
            <div key={group.label}>
              <p>{group.label}</p>
              {group.links.map(({ to, name, icon: Icon }) => (
                <Link key={to} to={to} params={{ workspace: workspace.slug }} activeProps={{ className: "active", "aria-current": "page" }}>
                  <Icon size={16} strokeWidth={1.5} />
                  {name}
                </Link>
              ))}
            </div>
          ))}
          <div className="ws-settings-member">
            <MiniAvatar name={me.name} />
            <div>
              <strong>{me.name}</strong>
              <small>
                {ROLE_LABELS[role]}
                {isOwner ? " · owner" : ""}
              </small>
            </div>
          </div>
        </nav>
        <div className="ws-settings-content">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
